module.exports = __webpack_public_path__ + "img/mopark.cb9deb0d.jpg";